import { ExperienceMapper } from '@ninetailed/experience.js-utils-contentful';
import { hasExperiences } from '~/utils/ninetailed/hasExperience';
import type { SingularBlock } from '~/utils/ninetailed/types';

export const parseExperiences = (entry: SingularBlock) => {
  return hasExperiences(entry)
    ? entry.fields.nt_experiences
        .filter((experience: (typeof entry.fields.nt_experiences)[number]) =>
          ExperienceMapper.isExperienceEntry(experience)
        )
        .map((experience: (typeof entry.fields.nt_experiences)[number]) =>
          ExperienceMapper.mapExperience(experience)
        )
    : [];
};
